<template>
    <div class="mt-4 mb-5">
        <div class="row">
            <div class="col-md-12">
                <p class="f17">
                    This section is used for domains that do not require a WordPress install.  The domains added here will be automatically redirected to
                    <b class="text-primary">{{selectedMainDomain}}</b>
                </p>
                <p class="f17">You will also have the ability to update the DNS records for this domain if needed.</p>
                <p class="text-danger">
                    <span class="badge badge-danger">Please note</span> In order for the redirect and DNS records to function, you are required to update the domains nameservers to point to the ones shown in the
                    <b>View Details</b> button.
                </p>
                <h5>
                    Add New Page Rule For:
                    <span class="text-primary">{{alias}}</span>
                </h5>
                <div class="row">
                    <div class="col-md-5">
                        <div class="form-group">
                            <input v-model.trim="alias" @keyup="typePattern()" type="text" class="form-control" placeholder="Type alias domain name without http, https or www" v-lowercase />
                        </div>
                    </div>
<!--                    <div class="col-md-5">-->
<!--                        <div class="form-group">-->
<!--                            <input v-model.trim="aliasPattern" type="text" class="form-control" placeholder="Domain Pattern..." v-lowercase />-->
<!--                        </div>-->
<!--                    </div>-->
                    <div class="col-md-2 text-right">
                        <button class="btn btn-outline-primary saveBtn" :disabled="loading" @click="saveSettings()">
                            <div class="loader small_loader" v-if="loading"></div>
                            <span v-else>Save</span>
                        </button>
                    </div>
                </div>
                <hr/>
                <div class="table-responsive">
                    <table class="table table-striped table-bordered domain_table">
                        <thead>
                            <tr>
                                <th class="text-center">Domain</th>
                                <th class="text-center">Redirect To</th>
                                <th class="text-center">Created On</th>
                                <th class="text-center">DNS</th>
                                <th class="text-center"><i class="fa fa-bolt"></i></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(aliasObj, index) in aliases" :key="index + '_' + aliasObj.domain">
                                <td class="text-center text-primary"><b><i>{{aliasObj.domain}}</i></b></td>
                                <td class="text-center">
                                    <span class="badge center badge-success"><b>{{selectedMainDomain}}</b></span>
                                </td>
                                <td class="text-center">
                                    <span class="badge center badge-info"><b>{{aliasObj.created | formatDate}}</b></span>
                                </td>
                                <td class="text-center">
                                    <button class="btn btn-danger btn-sm" @click="openDNSModal(aliasObj)">
                                        DNS
                                    </button>
                                </td>
                                <td class="text-center">
                                    <button class="btn btn-primary btn-sm" @click="viewDetailOfAlias(aliasObj)">View Details</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="modal" tabindex="-1" role="dialog" id="viewDetailModal" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h6 class="modal-title">Name Servers Of: {{selectedDomain.domain}}</h6>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <ul >
                            <li>{{account.cloudflare.nameserver1}}</li>
                            <li>{{account.cloudflare.nameserver2}}</li>
                        </ul>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-outline-default btn-sm" data-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal" tabindex="-1" role="dialog" id="viewAliasDNS" aria-hidden="true" style="overflow: auto">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h6 class="modal-title">DNS Of: {{selectedDomain.domain}}</h6>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="loader" v-if="loading"></div>
                        <dns-items v-if="!loading && selectedAliasDNSRecords.length > 0"
                                   :records="selectedAliasDNSRecords"
                                   :account="account"
                                   :loading="dnsLoading"
                                   :fromAlias="true"
                                   :selectedAlias="selectedDomain"
                                   v-on:update-list="listDNS"
                                   ref="dnsItems"
                                   v-on:update-loading="updateLoading"></dns-items>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-outline-default btn-sm" data-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" id="editRecordAlias" data-backdrop="false" tabindex="-1" role="dialog" aria-labelledby="editRecord" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title d-inline">Edit {{editItem.type}} record</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Type</label>
                            <div class="col-sm-9">
                                <select v-model="editItem.type" class="form-control" disabled>
                                    <option value="A">A</option>
                                    <option value="AAAA">AAAA</option>
                                    <option value="CNAME">CNAME</option>
                                    <option value="TXT">TXT</option>
                                    <option value="MX">MX</option>
                                </select>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label  class="col-sm-3 col-form-label">Name</label>
                            <div class="col-sm-9">
                                <input type="text" class="form-control" v-model="editItem.name" :disabled="loading"/>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label  class="col-sm-3 col-form-label">Value</label>
                            <div class="col-sm-9">
                                <input type="text" class="form-control" v-model="editItem.content" :disabled="loading"/>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label  class="col-sm-3 col-form-label">TTL</label>
                            <div class="col-sm-9">
                                <input type="text" class="form-control" v-model="editItem.ttl" :disabled="loading"/>
                            </div>
                        </div>
                        <div  v-if="editItem.type === 'MX'" class="form-group row">
                            <label  class="col-sm-3 col-form-label">Priority</label>
                            <div class="col-sm-9">
                                <input type="text" class="form-control" v-model="editItem.priority" :disabled="loading"/>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label  class="col-sm-3 col-form-label">Status</label>
                            <div class="col-sm-9">
                                <div class="custom-control custom-checkbox" style="top: -5px;">
                                    <input type="checkbox" :id="'proxied_modal_' + editItem.id" value="1" name="proxied" :disabled="loading" v-model="editItem.proxied" class="custom-control-input"/>
                                    <label class="custom-control-label" :for="'proxied_modal_' + editItem.id"></label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                        <button type="button" class="btn btn-primary" @click.prevent="update">
                            <div class="loader small_loader" v-if="action === 'update'"></div>
                            <span v-else>Save</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import swal from 'sweetalert2'
    import {db} from "@/firebase/init";
    import DnsItems from "../Dns/DnsItems";
    export default {
        name: "Domains",
        components: {
            DnsItems
        },
        data () {
          return {
              //////
              editItem: {},
              action: null,
              //////
              loading: false,
              dnsLoading: false,
              section: 'new',
              alias: '',
              aliasPattern: '',
              selectedMainDomain: '',
              settings: {
                  id: 'forwarding_url',
                  valueFU: '',
                  valueAO: 'on',
                  status_code: '301'
              },
              aliases: [],
              selectedAliasDNSRecords: [],
              updateDataTable: true,
              selectedDomain: {},
              firstTimeOpen: false
          }
        },
        props: {
            account: {
                type: Object,
                required: true
            },
            envType: {
                type: String,
                required: true
            },
            fromCollaborator: {
                type: Boolean,
                required: false
            },
            supervisor: {
                type: Object,
                required: false
            }
        },
        computed: {
            UID(){
                return this.$store.getters.getUID;
            }
        },
        watch: {
          envType(val) {
               if(val === 'live'){
                   this.selectedMainDomain = this.account.domain;
               }else{
                   this.selectedMainDomain = this.account.staging.domain;
               }
              this.settings.valueFU = 'https://' + this.selectedMainDomain + '/$2';
               this.fetchData();
          },
          account(){
              if(this.envType === 'live'){
                  this.selectedMainDomain = this.account.domain;
              }else{
                  this.selectedMainDomain = this.account.staging.domain;
              }
              this.settings.valueFU = 'https://' + this.selectedMainDomain + '/$2';
              this.fetchData();
          }
        },
        created() {
            this.fetchData();
        },
        mounted() {
            this.selectedMainDomain = this.account.domain;
            this.settings.valueFU = 'https://' + this.selectedMainDomain + '/$2';
        },
        updated(){
           if(this.updateDataTable){
               console.log('Updating DTs....');
               /* eslint-disable */
               $(`.domain_table`).DataTable({
                   destroy: true,
                   deferRender: true,
                   columnDefs: [
                       { orderable: false, targets: [0,1,3,4] }
                   ],
                   language: {
                       search: "_INPUT_",
                       searchPlaceholder: "Search records",
                       emptyTable: "No Alias Domains For This Account Currently"
                   }
               });
               /* eslint-enable */
               this.updateDataTable = false;
           }
        },
        methods: {
            update(){
                this.action = 'update';
                this.$refs.dnsItems.editItem = Object.assign({}, this.editItem);
                this.$refs.dnsItems.update();
            },
            viewDetailOfAlias(alias){
                this.selectedDomain = alias;
                console.log(this.account);
                this.openModal('viewDetailModal');
            },
            openModal(el){
                /* eslint-disable */
                $("#" + el).modal("show");
                $('.modal-backdrop').removeClass("modal-backdrop");
                /* eslint-enable */
            },
            fetchData() {
                this.aliases = [];
                const customerUID = (this.fromCollaborator) ? this.supervisor.supervisorId : this.UID;
                db.collection('hostingAccounts').doc(customerUID).get().then(doc => {
                    const { accounts } = doc.data();
                    if (this.account.addonIndex === null && this.envType === 'live' && accounts[this.account.planIndex].primary.aliases !== undefined) {
                       this.aliases = accounts[this.account.planIndex].primary.aliases;
                    } else if (this.account.addonIndex === null && this.envType === 'staging' && accounts[this.account.planIndex].primary.staging.aliases !== undefined) {
                        this.aliases = accounts[this.account.planIndex].primary.staging.aliases;
                    } else if(this.account.addonIndex !== null && this.envType === 'live' && accounts[this.account.planIndex].addon[this.account.addonIndex].aliases !== undefined) {
                        this.aliases = accounts[this.account.planIndex].addon[this.account.addonIndex].aliases;
                    } else if(this.account.addonIndex !== null && this.envType === 'staging' && accounts[this.account.planIndex].addon[this.account.addonIndex].staging.aliases !== undefined) {
                        this.aliases = accounts[this.account.planIndex].addon[this.account.addonIndex].staging.aliases;
                    }
                    this.reInitDataTable();
                });
                this.reInitDataTable();
            },
            reInitDataTable(){
                /* eslint-disable */
                $(`.domain_table`).DataTable().destroy();
                this.updateDataTable = true;
                /* eslint-enable */
            },
            changeSection(section){
                this.section = section;
            },
            typePattern(){
              this.aliasPattern = '*' + this.alias + '/*';
              if(this.alias === ''){
                  this.aliasPattern = '';
              }
            },
            saveSettings(){
                if(this.alias === ''){
                    swal('Error!', 'Please type valid domain!', 'error');
                    return;
                }
                if(this.settings.id === 'forwarding_url'){
                    this.settings.value = {
                        url: this.settings.valueFU, status_code: parseInt(this.settings.status_code)
                    }
                }else{
                    this.settings.value = this.settings.valueAO;
                }
                this.loading = true;
                console.log(this.account);
                console.log(this.alias);
                console.log(this.aliasPattern);
                console.log(this.settings);
                this.$http.post('/zone/settings/add-page-rule', {
                    grant_type: 'token',
                    cloudflare_email: this.account.cloudflare.username,
                    cloudflare_api_key: this.account.cloudflare.apiKey,
                    cloudflare_user_key: this.account.cloudflare.userKey,
                    alias: this.alias,
                    pattern: this.aliasPattern,
                    settings: this.settings,
                    UID: (!this.fromCollaborator) ? this.UID : this.supervisor.supervisorId,
                }).then(resp => {
                    console.log(resp);

                    const customerUID = (this.fromCollaborator) ? this.supervisor.supervisorId : this.UID;
                    db.collection('hostingAccounts').doc(customerUID).get().then(async doc => {
                        const { accounts } = doc.data();
                        const beforePayload = JSON.parse(JSON.stringify(accounts))
                        if(this.account.addonIndex === null && this.envType === 'live'){
                            let allAliases = accounts[this.account.planIndex].primary.aliases;
                            if(allAliases === undefined){
                                allAliases = [];
                            }
                            allAliases.push({
                                domain: this.alias,
                                pattern: this.aliasPattern,
                                zoneId: resp.data.zone,
                                created: new Date().toISOString()
                            });
                            accounts[this.account.planIndex].primary.aliases = allAliases;
                        }else if(this.account.addonIndex === null && this.envType === 'staging'){
                            let allAliases = accounts[this.account.planIndex].primary.staging.aliases;
                            if(allAliases === undefined){
                                allAliases = [];
                            }
                            allAliases.push({
                                domain: this.alias,
                                pattern: this.aliasPattern,
                                zoneId: resp.data.zone,
                                created: new Date().toISOString()
                            });
                            accounts[this.account.planIndex].primary.staging.aliases = allAliases;
                        }else if(this.account.addonIndex !== null && this.envType === 'live'){
                            let allAliases = accounts[this.account.planIndex].addon[this.account.addonIndex].aliases;
                            if(allAliases === undefined){
                                allAliases = [];
                            }
                            allAliases.push({
                                domain: this.alias,
                                pattern: this.aliasPattern,
                                zoneId: resp.data.zone,
                                created: new Date().toISOString()
                            });
                            accounts[this.account.planIndex].addon[this.account.addonIndex].aliases = allAliases;
                        }else if(this.account.addonIndex !== null && this.envType === 'staging'){
                            let allAliases = accounts[this.account.planIndex].addon[this.account.addonIndex].staging.aliases;
                            if(allAliases === undefined){
                                allAliases = [];
                            }
                            allAliases.push({
                                domain: this.alias,
                                pattern: this.aliasPattern,
                                zoneId: resp.data.zone,
                                created: new Date().toISOString()
                            });
                            accounts[this.account.planIndex].addon[this.account.addonIndex].staging.aliases = allAliases;
                        }
                        const customerUID = (this.fromCollaborator) ? this.supervisor.supervisorId : this.UID;
                        await this.addHostingAccountEventLog({hostingAccountId : this.docID ,  afterPayload: accounts , beforePayload : beforePayload, action: 'Adding DNS Rule'})
                        await db.collection('hostingAccounts').doc(customerUID).update({
                            accounts: accounts
                        }).then(() => {
                            this.loading = false;
                            this.alias = '';
                            this.aliasPattern = '';
                            this.fetchData();
                            swal('Added!', 'Page rule has been added successfully.', 'success');
                        })
                    });

                }).catch(e => {
                    console.log(e.response);
                    this.loading = false;
                    if(e.response.data.errors && e.response.data.errors.length > 0){
                        let eHtml = '<ul style="text-align: left">';
                        for(let error of e.response.data.errors){
                            eHtml +='<li>'+error.msg+'</li>'
                        }
                        eHtml += '</ul>';
                        swal({
                            title: "Error!",
                            html: eHtml,
                            type: 'error',
                        });
                        return;
                    }
                    swal('Error!', e.response.data.message, 'error');
                })
            },
            openDNSModal(alias){
                this.selectedDomain = alias;
                this.listDNS();
                this.openModal('viewAliasDNS');
            },
            listDNS(){
                this.loading = true;
                this.$http.post("dns", {
                    domain: this.selectedDomain.domain,
                    grant_type: "token",
                    cloudflare_email: this.account.cloudflare.username,
                    cloudflare_api_key: this.account.cloudflare.apiKey,
                    cloudflare_zone: this.selectedDomain.zoneId,
                })
                    .then((response) => {
                        console.log(response.data.data);
                        this.selectedAliasDNSRecords = response.data.data;
                    })
                    .catch((err) => {
                        this.addLog({
                            name: this.user.firstName + " " + this.user.lastName,
                            message: `Error show DNS list. Message: ${err.message} Code: ${err.code}`,
                            level: "danger"
                        });
                    })
                    .finally(()=>{
                        this.loading = false;
                    });
            },
            updateLoading(value){
                this.dnsLoading = value;
            }
        }
    }
</script>

<style scoped>
.saveBtn{
    margin-top: 0 !important;
    margin-bottom: 0 !important;
    line-height: 0.9em !important;
}
    .f17{
        font-size: 16px;
    }
</style>
